import MobileDetect from 'mobile-detect';
import urlJoin from "url-join";

const md = new MobileDetect(window.navigator.userAgent);

const utilities = {
    md: md,
    loadImage: (map, key, imageUrl) => {
        return new Promise((resolve, reject) => {
            if (!map || !imageUrl) reject();
            map.loadImage(imageUrl, (error, image) => {
                if (!!error) {
                    reject(error);
                }
                map.addImage(key, image);
                resolve();
            });
        });
    },
    getMapPadding: (appId) => {
        let sidebar = $(`#${appId} .dc-sidebar`);
        let sidebarWidth = 0;
        if (sidebar.length > 0 && !md.mobile())
            sidebarWidth = sidebar.width();
        return {
            top: 50,
            bottom: 50,
            right: 50,
            left: sidebarWidth + 50
        }
    },
    getDetailpageUrl(id, locale){
        //return `http://donautouristik.pixeldev.at/schiffsreise-detail?dcid=${id}&no_cache=1`;
        const localeParameter = !!locale ? `&lang=${locale}` : '';
        return `https://donautouristik.pixeldev.at/reise-detail?dcid=${id}${localeParameter}&no_cache=1`;
    },
    getPoiDetailpageUrl(id, locale){
        //return `http://donautouristik.pixeldev.at/schiffsreise-detail?dcid=${id}&no_cache=1`;
        const localeParameter = !!locale ? `&lang=${locale}` : '';
        return `https://donautouristik.pixeldev.at/poi-detail?dcid=${id}${localeParameter}&no_cache=1`;
    },
    createEndpoint(apiHost, endpoint){
        return urlJoin(apiHost, 'endpoints', endpoint);
    },
    objectToQuerystring (obj) {
        let params = {};
        Object.keys(obj).forEach((key) => (!!obj[key]) && (params[key] = obj[key]));
        return $.param(params);
    },
    searchUrl(
        apiHost,
        endpoint,
        pageNumber,
        pageSize,
        include,
        fields,
        categories,
        query,
        language
        ){
        let apiUrl = utilities.createEndpoint(apiHost, endpoint);
        let parameters = {
          page:{
              size: pageSize || 25,
              number: pageNumber || 1
          }
        };
        if(!!language){
            parameters.language = language;
        }
        if(!!include){
            parameters.include = _.isArray(include) ? include.join(",") : include;
        }
        if(!!fields &&
            (   _.isString(fields) ||
                (_.isArray(fields) && fields.length > 0)
            )
        ){
            parameters.fields = _.isArray(fields) ? fields.join(",") : fields;
        }
        if(!!categories && categories.length > 0){
            parameters.filter = parameters.filter || {};
            parameters.filter.classifications = {in:{withSubtree:[]}};
            categories.map(category => {
                if(!!category && !!category.id)
                    parameters.filter.classifications.in.withSubtree.push(category.id);
            });
        }
        if(!!query){
            parameters.filter = parameters.filter || {};
            parameters.filter.q = query;
        }
        const queryParameters = utilities.objectToQuerystring(parameters);
        if(!!queryParameters)
            return `${apiUrl}?${queryParameters}`;
        else
            return apiUrl;
    },
    // function to compensate for the "dynamic nature" of datacycle. Data consistency, ever heard of it?????
    getVariable(obj, dotSeparatedPath){
        if(!dotSeparatedPath)
            return obj;
        let part = dotSeparatedPath.split(".")[0];

    },
    convertTripToTile(item, locale){
        const tripId = _.get(item, '@id');
        let tour = _.get(item, 'details[0].tour', null);
        locale = locale || '';
        return {
            id: tripId,
            active: _.get(item, '@id') == _.get(this.activeTrip, 'id'),
            image: _.get(item, 'details[0].image[0].thumbnailUrl', ''),
            title: _.get(item, 'name'),
            subtitle: '',
            disabled: tour == null ? 'disabled' : '',
            link: utilities.getDetailpageUrl(tripId, locale),
            original: item
        };
    }
};
export default utilities;